module.exports = __webpack_public_path__ + "static/media/bank_300_01.5db4d70c.png";